module.exports = __webpack_public_path__ + "static/media/flash.e9bc1aed.svg";